import React from 'react';
import './WhyFatlSection.css';
import useScrollAnimation from '../hooks/useScrollAnimation';

const WhyFatlSection = () => {
  const textRef = useScrollAnimation(200);
  const imageRef = useScrollAnimation(400);

  return (
    <section id="why-fatl-section" className="why-fatl-section">
      <div className="why-fatl-content">
        <div ref={textRef} className="why-fatl-text animate-on-scroll animate-fade-in-left">
          <h2 className="main-question">لماذا منصة فتل هي خيارك الأفضل؟</h2>
          <p className="sub-text">
            نوجههم نحو الاختيار الأمثل بثقة تامة بعون الله
            <span className="quote-marks">"</span>
          </p>
        </div>
        <div ref={imageRef} className="why-fatl-image animate-on-scroll animate-fade-in-right">
          <img src="/Frame 1000001655.png" alt="Why Choose Fatl Platform" className="banner-img" />
        </div>
      </div>
    </section>
  );
};

export default WhyFatlSection;


